
import { computed, defineComponent, watch } from 'vue'
import { useRoute } from 'vue-router'
import LocalNav from '@/components/block/LocalNav.vue'
import MagazineCard from '@/components/block/MagazineCard.vue'
import MagazineEventArchive from '@/components/block/MagazineEventArchive.vue'
import Pagination from '@/components/block/Pagination.vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import { useSpecial } from '@/provider/special'
import { MagazineSpecialOutline } from '@/types/MagazineSpecial'

export default defineComponent({
  name: 'MagazinesSpecial',

  components: {
    LocalNav,
    MagazineCard,
    HeadingLv1,
    MagazineEventArchive,
    Pagination
  },

  setup() {
    const localNav = [
      {
        id: 'test',
        label: '試験対策'
      },
      {
        id: 'matching',
        label: 'マッチング基礎知識'
      }
    ]

    const route = useRoute()
    const { state, loadContents } = useSpecial()
    const loadSpecialContents = () => {
      loadContents({
        perPage: 6,
        page: route.query.page ? Number(route.query.page) : undefined,
        parentCategory: 'special'
      })
    }
    watch(
      () => [route.params.id, route.query.page],
      (next, prev) => {
        if (JSON.stringify(next) === JSON.stringify(prev)) return
        loadSpecialContents()
      },
      { immediate: true }
    )

    const totalPages = computed(() => state.totalPages)

    const outlines = computed((): MagazineSpecialOutline[] =>
      state.contents.map((content) => ({
        ...content,
        category: content.childCategories[0]?.name ?? ''
      }))
    )

    return {
      localNav,
      totalPages,
      outlines
    }
  }
})
